import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { ScreenDeviceModel, TScreenDevice } from '../models/screen_device_model';

interface IScreenDeviceQueryResult {
  screenDevice: TScreenDevice;
  isScreenDesktop: boolean;
  isScreenMobile: boolean;
}

export class ScreenDeviceQuery implements IQuery {
  private _result: IScreenDeviceQueryResult;

  constructor(private ngScreenDeviceModel: ScreenDeviceModel) {
    Query.registerQuery(this, ngScreenDeviceModel);
  }

  run() {
    const currentScreenDevice = this.ngScreenDeviceModel.read().screen_device;
    this._result = {
      screenDevice: currentScreenDevice,
      isScreenDesktop: currentScreenDevice === 'desktop',
      isScreenMobile: currentScreenDevice === 'mobile'
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('ng-screen-query').service('ngScreenDeviceQuery', ScreenDeviceQuery);



// WEBPACK FOOTER //
// ./app/vendor/screen-query/src/queries/screen_device_query.ts